import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { style: {"overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { style: {"overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { style: {"overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_13 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_14 = {
  key: 1,
  style: {"overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_15 = { key: 5 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_18 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_19 = {
  key: 1,
  style: {"overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_20 = { key: 6 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_23 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 0,
  style: {"overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 7 }
const _hoisted_28 = {
  key: 0,
  style: {"overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 8 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_33 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 0,
  style: {"overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 9 }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_40 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 0,
  style: {"overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 10 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_47 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 0,
  style: {"overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 11 }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { key: 12 }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 附件 ", -1)
const _hoisted_56 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { style: {"margin-left":"3px"} }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { style: {"margin-left":"3px"} }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { style: {"font-size":"14px","height":"24px"} }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-document" }, null, -1)
const _hoisted_67 = { style: {"font-size":"12px","cursor":"pointer","color":"#409eff"} }
const _hoisted_68 = ["href"]
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "暂无数据", -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { style: {"text-align":"center"} }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0px 0px 20px 20px"} }, "所勾选信息包含移库数据，如需剔除请使用搜索功能重新筛选信息", -1)
const _hoisted_74 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_75 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_76 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_miezz_wharf_warehousing = _resolveComponent("miezz-wharf-warehousing")!
  const _component_miezz_wharf_box_sticker = _resolveComponent("miezz-wharf-box-sticker")!
  const _component_miezz_supplier = _resolveComponent("miezz-supplier")!
  const _component_miezz_shiftout = _resolveComponent("miezz-shiftout")!
  const _component_miezz_wharf_plan = _resolveComponent("miezz-wharf-plan")!
  const _component_miezz_wharf_in_stock = _resolveComponent("miezz-wharf-in-stock")!
  const _component_miezz_wharf_out_stock = _resolveComponent("miezz-wharf-out-stock")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_order_pool_choose_service = _resolveComponent("order-pool-choose-service")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_miezz_page_list, {
      modelValue: _ctx.list,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list) = $event)),
      onHandleGet: _ctx.handleGet,
      onHandleTopButtonClick: _ctx.handleTopButtonClick,
      onHandleRowButtonClick: _ctx.handleRowButtonClick,
      onHandleBottomButtonClick: _ctx.handleBottomButtonClick,
      onHandleDragSort: _ctx.handleDragSort
    }, {
      "dynamic-search-customize": _withCtx(({ model }) => [
        (model.Where.Prop == 'DynamicSearch_Port')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 0,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.ports,
              clearable: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : _createCommentVNode("", true),
        (model.Where.Prop == 'DynamicSearch_ClientCompanyId')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 1,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.clientUsers,
              clearable: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : (model.Where.Prop == 'DynamicSearch_SupplierCompanyId')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 2,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.serviceProviders,
                "label-key": "NameZh",
                "value-key": "Id",
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : (
          model.Where.Prop == 'DynamicSearch_DeparturePortIncomingGoodsStatus'
        )
              ? (_openBlock(), _createBlock(_component_miezz_select, {
                  key: 3,
                  modelValue: model.Where.Value,
                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                  options: _ctx.EnumIncomingGoodsStatusOption,
                  number: true,
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
              : (
          model.Where.Prop == 'DynamicSearch_DestinationPortIncomingGoodsStatus'
        )
                ? (_openBlock(), _createBlock(_component_miezz_select, {
                    key: 4,
                    modelValue: model.Where.Value,
                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                    options: _ctx.EnumIncomingGoodsStatusOption,
                    number: true,
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                : _createCommentVNode("", true)
      ]),
      column: _withCtx((scoped) => [
        (scoped.model.Prop == 'OrderCode')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.isString(scoped.row.OrderCode)), 1)
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'BookingNo')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.isString(scoped.row.BookingNo)), 1)
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'ClientCompany')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.isString(scoped.row.ClientCompany.NameZh)), 1)
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'Port')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.isString(scoped.row.Port)), 1)
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'InStockTime')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.isEdit==true)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.onInStockTime(scoped.row)),
                    style: {"cursor":"pointer"}
                  }, [
                    (scoped.row.InStockTime)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(scoped.row.InStockTime), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, " 暂无数据 "))
                  ], 8, _hoisted_11))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.isString(scoped.row.InStockTime)), 1))
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'OutStockTime')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_ctx.isEdit==true)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.onOutStockTime(scoped.row)),
                    style: {"cursor":"pointer"}
                  }, [
                    (scoped.row.OutStockTime)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(scoped.row.OutStockTime), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, " 暂无数据 "))
                  ], 8, _hoisted_16))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.isString(scoped.row.OutStockTime)), 1))
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'Plans')
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_ctx.isEdit==true)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.onPlan(scoped.row)),
                    style: {"cursor":"pointer"}
                  }, [
                    (scoped.row.SumQuantity)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(scoped.row.SumQuantity + scoped.row.ChargeUnit) + "/" + _toDisplayString(scoped.row.SumGrossWeight) + "KGS/" + _toDisplayString(scoped.row.SumVolume) + "CBM ", 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_23, " 暂无数据 "))
                  ], 8, _hoisted_21))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (scoped.row.SumQuantity)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(scoped.row.SumQuantity + scoped.row.ChargeUnit) + "/" + _toDisplayString(scoped.row.SumGrossWeight) + "KGS/" + _toDisplayString(scoped.row.SumVolume) + "CBM ", 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_26, " 暂无数据 "))
                  ]))
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'ReceivingDeadline')
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              (scoped.row.ReceivingDeadline)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.formatTime(scoped.row.ReceivingDeadline)), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, " 暂无数据 "))
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'InStocks')
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              (_ctx.isEdit==true)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.onInStock(scoped.row)),
                    style: {"cursor":"pointer"}
                  }, [
                    (scoped.row.SumQuantityInStock)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(scoped.row.SumQuantityInStock + scoped.row.ChargeUnitInStock) + "/" + _toDisplayString(scoped.row.SumGrossWeightInStock) + "KGS/" + _toDisplayString(scoped.row.SumVolumeInStock) + "CBM ", 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_33, " 暂无数据 "))
                  ], 8, _hoisted_31))
                : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    (scoped.row.SumQuantityInStock)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(scoped.row.SumQuantityInStock + scoped.row.ChargeUnitInStock) + "/" + _toDisplayString(scoped.row.SumGrossWeightInStock) + "KGS/" + _toDisplayString(scoped.row.SumVolumeInStock) + "CBM ", 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, "暂无数据"))
                  ]))
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'OutStocks')
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              (_ctx.isEdit==true)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.onOutStock(scoped.row)),
                    style: {"cursor":"pointer"}
                  }, [
                    (scoped.row.SumQuantityOutStock)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(scoped.row.SumQuantityOutStock + scoped.row.ChargeUnitOutStock) + "/" + _toDisplayString(scoped.row.SumGrossWeightOutStock) + "KGS/" + _toDisplayString(scoped.row.SumVolumeOutStock) + "CBM ", 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_40, " 暂无数据 "))
                  ], 8, _hoisted_38))
                : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    (scoped.row.SumQuantityOutStock)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(scoped.row.SumQuantityOutStock + scoped.row.ChargeUnitOutStock) + "/" + _toDisplayString(scoped.row.SumGrossWeightOutStock) + "KGS/" + _toDisplayString(scoped.row.SumVolumeOutStock) + "CBM ", 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_43, " 暂无数据 "))
                  ]))
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'Supplier')
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              (_ctx.isEdit == true)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.onSupplier(scoped.row)),
                    style: {"cursor":"pointer"}
                  }, [
                    (scoped.row.Supplier)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(scoped.row.Supplier), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_47, " 暂无数据 "))
                  ], 8, _hoisted_45))
                : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    (scoped.row.Supplier)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(scoped.row.Supplier), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_50, " 暂无数据 "))
                  ]))
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'GoodsInventory')
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _createElementVNode("div", {
                onClick: ($event: any) => (_ctx.onGoods(scoped.row))
              }, [
                _createVNode(_component_miezz_text_ellipsis, {
                  text: scoped.row.IsGoods==true ? '查看详情' : '暂无数据',
                  style: _normalizeStyle((scoped.row.IsGoods == true) ? 'color: #409EFF' : 'color: #fe995b')
                }, null, 8, ["text", "style"])
              ], 8, _hoisted_52)
            ]))
          : _createCommentVNode("", true),
        (scoped.model.Prop == 'Annexs')
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _createElementVNode("div", {
                onClick: ($event: any) => (_ctx.onAnnex(scoped.row)),
                style: {"cursor":"pointer","color":"#409EFF","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
              }, " 查看详情 ", 8, _hoisted_54)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onHandleGet", "onHandleTopButtonClick", "onHandleRowButtonClick", "onHandleBottomButtonClick", "onHandleDragSort"]),
    (_ctx.annexRuleForm.Data != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.annexRuleForm.Data.Visiable,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.annexRuleForm.Data.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_miezz_form, {
              ref: "refAnnexRuleForm",
              modelValue: _ctx.annexRuleForm,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.annexRuleForm) = $event)),
              fix: true
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'Warehouse')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "进仓通知",
                      "label-width": "100px"
                    }, {
                      label: _withCtx(() => [
                        (_ctx.annexRuleForm.Data.IsDetail != true)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: _normalizeStyle((_ctx.list.Data.AddDeparturePortWarehouse == true || _ctx.list.Data.AddDestinationPortWarehouse == true) ? 'color:red;font-weight:900;' : ' ')
                            }, " 进仓通知 ", 4))
                          : (_openBlock(), _createElementBlock("span", _hoisted_57, "进仓通知"))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { style: {"font-size":"20px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Document)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.annexRuleForm.Data.Code), 1),
                        _createElementVNode("span", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onWarehousing(_ctx.annexRuleForm.Data.OrderDepartureWharfId))),
                          href: "javascript:;",
                          style: {"margin-left":"10px","cursor":"pointer","color":"#409eff"}
                        }, [
                          (_ctx.isEdit == true)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_59, "编辑"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_60, "查看"))
                        ]),
                        _createElementVNode("span", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onWarehousingExport(_ctx.annexRuleForm.Data))),
                          href: "javascript:;",
                          style: {"margin-left":"5px","cursor":"pointer","color":"#409eff"}
                        }, "导出")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (item.Prop == 'Box' && _ctx.isBoxSticker == true)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "箱贴",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { style: {"font-size":"20px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Document)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.annexRuleForm.Data.BoxStickerCode), 1),
                        _createElementVNode("span", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onBoxSticker(_ctx.annexRuleForm.Data.OrderDepartureWharfId))),
                          href: "javascript:;",
                          style: {"margin-left":"10px","cursor":"pointer","color":"#409eff"}
                        }, [
                          (_ctx.isEdit == true)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_62, "编辑"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_63, "查看"))
                        ]),
                        _createElementVNode("span", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onBoxStickerExport(_ctx.annexRuleForm.Data))),
                          href: "javascript:;",
                          style: {"margin-left":"5px","cursor":"pointer","color":"#409eff"}
                        }, "导出")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (item.Prop == 'OrderDepartureWharfId' && _ctx.annexRuleForm.Data.IsDetail != true)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "附件",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.annexRuleForm.Data.Annexs,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.annexRuleForm.Data.Annexs) = $event)),
                          path: "orderDepartureWharf/annex",
                          accept: "file/*",
                          prop: "Url",
                          maxSize: 5 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (item.Prop == 'OrderDepartureWharfId' && _ctx.annexRuleForm.Data.IsDetail == true)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      label: "附件",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.annexRuleForm.Data.Annexs != null && _ctx.annexRuleForm.Data.Annexs != undefined && _ctx.annexRuleForm.Data.Annexs.length > 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_64, [
                              _createElementVNode("td", _hoisted_65, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annexRuleForm.Data.Annexs, (p, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    style: {"line-height":"24px"},
                                    key: index
                                  }, [
                                    _hoisted_66,
                                    _createTextVNode(" 附件-" + _toDisplayString(index + 1), 1)
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("td", _hoisted_67, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annexRuleForm.Data.Annexs, (p, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    style: {"line-height":"24px"},
                                    key: index
                                  }, [
                                    _createElementVNode("a", {
                                      style: {"color":"#409eff","text-decoration":"none"},
                                      target: "_blank",
                                      href: p.Url
                                    }, "预览", 8, _hoisted_68)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("tr", _hoisted_69, _hoisted_71))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_72, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annexBottomButtons, (item, i) => {
                return (_openBlock(), _createBlock(_component_miezz_button, {
                  style: {"width":"65px"},
                  key: i,
                  model: item,
                  onHandleClick: _ctx.handleClickAnnex
                }, null, 8, ["model", "onHandleClick"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_wharf_warehousing, {
      onOnInitAnnex: _ctx.onInitAnnex,
      ref: "Warehousing",
      orderPoolId: _ctx.poolId,
      isDetail: _ctx.isDetail
    }, null, 8, ["onOnInitAnnex", "orderPoolId", "isDetail"]),
    _createVNode(_component_miezz_wharf_box_sticker, {
      onOnInitAnnex: _ctx.onInitAnnex,
      ref: "BoxSticker",
      orderPoolId: _ctx.poolId,
      isDetail: _ctx.isDetail
    }, null, 8, ["onOnInitAnnex", "orderPoolId", "isDetail"]),
    _createVNode(_component_miezz_supplier, {
      ref: "Supplier",
      isDetail: _ctx.isDetail,
      onOnSelectSupplier: _ctx.onSelectSupplier
    }, null, 8, ["isDetail", "onOnSelectSupplier"]),
    _createVNode(_component_miezz_shiftout, {
      ref: "Shiftout",
      onOnSelectShiftout: _ctx.onSelectShiftout
    }, null, 8, ["onOnSelectShiftout"]),
    _createVNode(_component_miezz_wharf_plan, {
      ref: "WharfPlan",
      isDetail: _ctx.isDetail,
      onOnSelectPlan: _ctx.onSelectPlan,
      onOnAutoAddPlan: _ctx.onAutoAddPlan
    }, null, 8, ["isDetail", "onOnSelectPlan", "onOnAutoAddPlan"]),
    (_openBlock(), _createBlock(_component_miezz_wharf_in_stock, {
      key: _ctx.inStockKey,
      ref: "WharfInStock",
      orderPoolId: _ctx.poolId,
      isDetail: _ctx.isDetail,
      onOnSelectInStock: _ctx.onSelectInStock
    }, null, 8, ["orderPoolId", "isDetail", "onOnSelectInStock"])),
    _createVNode(_component_miezz_wharf_out_stock, {
      ref: "WharfOutStock",
      orderPoolId: _ctx.poolId,
      isDetail: _ctx.isDetail,
      onOnSelectOutStock: _ctx.onSelectOutStock
    }, null, 8, ["orderPoolId", "isDetail", "onOnSelectOutStock"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalStatistics,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalStatistics) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_73,
        _createVNode(_component_el_table, {
          data: _ctx.tableStatisticsData,
          border: "",
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { label: "计划货量" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.SumQuantity) + _toDisplayString(scope.row.ChargeUnit) + "/" + _toDisplayString(scope.row.SumVolume.toRound(2)) + "CBM/" + _toDisplayString(scope.row.SumGrossWeight.toRound(2)) + "KGS ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "入库货量" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.SumQuantityInStock) + _toDisplayString(scope.row.ChargeUnitInStock) + "/" + _toDisplayString(scope.row.SumVolumeInStock.toRound(2)) + "CBM/" + _toDisplayString(scope.row.SumGrossWeightInStock.toRound(2)) + "KGS ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "出库货量" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.SumQuantityOutStock) + _toDisplayString(scope.row.ChargeUnitOutStock) + "/" + _toDisplayString(scope.row.SumVolumeOutStock.toRound(2)) + "CBM/" + _toDisplayString(scope.row.SumGrossWeightOutStock.toRound(2)) + "KGS ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalChooseService,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalChooseService) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_order_pool_choose_service, {
          modelValue: _ctx.modalChooseService,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalChooseService) = $event)),
          id: _ctx.poolId,
          stock: true,
          orderWarehouseId: _ctx.id,
          orderServiceType: _ctx.orderServiceType,
          onHandleSubmit: _ctx.handleChooseServiceSubmit
        }, null, 8, ["modelValue", "id", "orderWarehouseId", "orderServiceType", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.timeRuleForm.Data != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.timeRuleForm.Data.Visiable,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.timeRuleForm.Data.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.timeRuleForm.Data.Title), 1),
            _createElementVNode("div", _hoisted_75, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_miezz_form, {
              ref: "refTimeRuleForm",
              modelValue: _ctx.timeRuleForm,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.timeRuleForm) = $event)),
              fix: true
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'Time')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: item.Prop,
                      label: _ctx.timeRuleForm.Data.Label
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.timeRuleForm.Data.Time,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.timeRuleForm.Data.Time) = $event)),
                          type: "datetime",
                          style: {"width":"100% !important"},
                          placeholder: "请选择",
                          format: "YYYY/MM/DD HH:mm",
                          "default-time": _ctx.defaultTime
                        }, null, 8, ["modelValue", "default-time"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_76, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeBottomButtons, (item, i) => {
                return (_openBlock(), _createBlock(_component_miezz_button, {
                  style: {"width":"65px"},
                  key: i,
                  model: item,
                  onHandleClick: _ctx.handleClickTime
                }, null, 8, ["model", "onHandleClick"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}